/**
 * @class
 * Show A PopUp Alert Dialog.
 */
class PopUpAlerts_JS {
    /**
     * @constructor
     * @param {String} pMessage Body HTML Message.
     * @param {String} pTitle Title for the modal.
     * @param {ICONS} pIconType Icon Type.
     * @param {String} ptxtCancelBtn text for the cancel button.
     * @param {String} pIDModal PopUp ID.
     * @param {Boolean} pSetSmallText True For smallText.
     */
    constructor(pMessage = '', pTitle = '', pIconType = JFMUI_CONST.ICONS.INFO, ptxtCancelBtn = 'Cerrar', pIDModal = 'Alert', pSetSmallText = false) {
        /**
         * Modal Id.
         * @type {String}
         * @public
         */
        this.IDModal = `PopUp_${pIDModal}`;
        /**
         * Icon object.
         * @type {Icon_JS}
         * @public
         */
        this.Icon = new Icon_JS({
            IType: pIconType,
            width: 50,
            height: 50
        });
        /**
         * Modal Template.
         * @type {string}
         * @public
         */
        this.Template =
            "<div class='modal fade' tabindex='-1'>" +
            "<div class='modal-dialog modal-dialog-centered' style='min-height:50%;'>" +
            "<div class='modal-content'>" +
            "<div class='modal-header bg-primary bg-gradient py-1'>" +
            "<h5 class='modal-title text-light fw-semibold'>Modal title</h5>" +
            "<button type='button' class='btn-close btn-close-white' data-bs-dismiss='modal' aria-label='Close'></button>" +
            "</div>" +
            "<div class='modal-body d-flex text-break align-items-center px-4 w-100'>" +
            "<div class='modal-icon'></div>" +
            "<div><p class='modal-message ms-2 fs-5 my-0'>Modal body text goes here.</p></div>" +
            "</div>" +
            "<div class='modal-footer border-0 justify-content-around'>" +
            "<button type='button' class='btn btn-danger closeBtn' data-bs-dismiss='modal'>Close</button>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>";
        /**
         * Cancel Button text
         * @type {string}
         * @public
         */
        this.TxtCancelBtn = ptxtCancelBtn;
        /**
         * Modal Title.
         * @type {string}
         * @public
         */
        this.Title = pTitle;
        /**
         * Body HTML message.
         * @type {string}
         * @public
         */
        this.BodyMessage = pMessage;
        /**
         * Set small text.
         * @type {Boolean}
         * @public
         */
        this.SetSmallText = pSetSmallText;
        /**
         * Modal HTML.
         * @type {HTMLDivElement}
         * @public
         */
        this.ModalHTML = null;
        // Initialize Modal.
        this.init();
    }
    /**
     * Initialize PopUp Modal.
     * @private
     */
    init() {
        //Update HTML Modal.
        this.updateTemplate(this.Template);
        //Insert content to the model.
        this.refresh();
    }
    /**
     * Update HTML Modal Template.
     * @param {String} pTemplate New HTML template.
     */
    updateTemplate(pTemplate) {
        //Update Template
        this.Template = pTemplate;
        // Create DocumentFragment from text template.
        this.ModalHTML = DOM_Utility.createHTMLFromString(pTemplate);

        if (!this.ModalHTML) {
            throw new Error(`Invalid Template content: ${this.Template}`);
        }
    }
    /**
     * Refresh the dialog elements
     * */
    refresh() {
        let objTitle = this.ModalHTML.querySelector('.modal-title'),
            objModalBodyIcon = this.ModalHTML.querySelector('.modal-icon'),
            objBodyMessage = this.ModalHTML.querySelector('.modal-message'),
            objBtnFooter = this.ModalHTML.querySelector('.modal-footer > .closeBtn');

        //assing ID selector.
        this.ModalHTML.id = this.IDModal;

        //Set content
        !!objTitle && (objTitle.innerHTML = this.Title);
        !!objBodyMessage && (objBodyMessage.innerHTML = this.BodyMessage);
        //Style text
        if (this.SetSmallText) {
            !!objBodyMessage && objBodyMessage.classList.add('fs-6');
            !!objBtnFooter && objBtnFooter.classList.add('btn-sm');
            !!objTitle && objTitle.classList.add('fs-6');
            this.Icon.Height = 30;
            this.Icon.Width = 30;
            this.Icon.init();
        }
        // Add Icon
        !!objModalBodyIcon && (objModalBodyIcon.innerHTML = this.Icon.generateIcon().outerHTML);
        // Update close text
        !!objBtnFooter && (objBtnFooter.innerHTML = this.TxtCancelBtn);
    }
    /**
     * Show PopUp Alert.
     */
    show() {
        this.refresh();
        this.showPopUpAlert();
    }
    /**
     * Show Modal Pop Up Alert
     * @returns {bootstrap.Modal} Modal control
     */
    showPopUpAlert() {
        let objThis = this,
            bootstrapModal = null;
        //Add Modal to the DOM.
        document.body.appendChild(this.ModalHTML);
        // Build bootstrap.Modal
        bootstrapModal = new bootstrap.Modal(this.ModalHTML, {
            backdrop: 'static'
        })
        bootstrapModal.show(); // show the dialog

        // on close Modal event
        this.ModalHTML.addEventListener('hidden.bs.modal', function (event) {
            objThis.ModalHTML.remove();
        });

        return bootstrapModal;
    }
}
/**
 * @class
 * Show A PopUp Confirm Modal.
 * @augments PopUpAlerts_JS
 */
class PopUpConfirm_JS extends PopUpAlerts_JS {
    /**
     * @param {String} pMessage Body HTML Message.
     * @param {String} pTitle Title for the modal.
     * @param {String} ptxtOKBtn Text for the OK button.
     * @param {String} ptxtCancelBtn text for the cancel button.
     * @param {String} pIDModal PopUp ID.
     * @param {Boolean} pSetSmallText True For smallText.
     * @constructor
     */
    constructor(pMessage = '', pTitle = '', ptxtOKBtn = 'Aceptar', ptxtCancelBtn = 'Cancelar', pIDModal = 'PopUpConfirm', pSetSmallText = false) {
        super(pMessage, pTitle, JFMUI_CONST.ICONS.CONFIRM, ptxtCancelBtn, pIDModal, pSetSmallText);
        /**
         * Text for the OK button.
         * @type {string}
         * @public
         */
        this.TxtOKBtn = ptxtOKBtn;
        /**
         * Template for the OK button.
         * @type {string}
         * @public
         */
        this.ButtonOKTemplate = "<button type='button' class='btn btn-primary OkBtn' data-bs-dismiss='modal'>OK</button>";
        this.initModal();
    }
    /**
     * Initialize Modal
     */
    initModal() {
        this.updateTemplateConfirm(this.Template);
        this.refreshConfirm();
    }
    /**
     * Update template
     * @param {String} pTemplate 
     */
    updateTemplateConfirm(pTemplate) {

        this.updateTemplate(pTemplate);

        let objFooter = this.ModalHTML.querySelector('.modal-footer'),
            objOkBtn = this.ModalHTML.querySelector('.modal-footer > .OkBtn'),
            objCancelBtn = this.ModalHTML.querySelector('.modal-footer > .closeBtn');

        if (!objOkBtn) {
            !!objFooter && objFooter.insertAdjacentHTML('afterbegin', this.ButtonOKTemplate);
        }

        !!objFooter && (objFooter.classList.remove('justify-content-around'), objFooter.classList.add('justify-content-end'));
        !!objCancelBtn && (objCancelBtn.classList.remove('btn-danger'), objCancelBtn.classList.add('btn-outline-danger'));
    }
    /**
     * Refresh Confirm text message.
     */
    refreshConfirm() {
        this.refresh();
        let objBtnOk = this.ModalHTML.querySelector('.modal-footer > .OkBtn');

        //Style text
        if (this.SetSmallText) {
            !!objBtnOk && objBtnOk.classList.add('btn-sm');
        }
        // Update text
        !!objBtnOk && (objBtnOk.innerHTML = this.TxtOKBtn);
    }
    /**
     * Show PopUp Confirm Modal
     * @param {Function} pFnCallback On click in Button OK, execute pFnCallback.
     * @returns {bootstrap.Modal}
     * @private
     */
    showPopUpConfirm(pFnCallback) {
        let bootstrapModal = super.showPopUpAlert(), // show the dialog through the father
            objBtnOk = this.ModalHTML.querySelector('.modal-footer > .OkBtn');
        !!objBtnOk && objBtnOk.addEventListener('click', function (event) {
            pFnCallback(event);
        });
        return bootstrapModal;
    }
    /**
     * Show PopUp Confirm Modal
     * @param {Function} pFnCallback On click in Button OK, execute pFnCallback.
     * @returns {bootstrap.Modal}
     * @public
     */
    show(pFnCallback) {
        //refresh Confirm Modal text message.
        this.refreshConfirm();
        return this.showPopUpConfirm(pFnCallback);
    }
}